export default function isValidDate(dateString: string | undefined): boolean {
    if(!dateString) return false;
    const date = new Date(dateString);
    return !isNaN(date.getTime());
}